import type { ProductSelectionParams } from '../types/product_selection'

/**
 * Builds a product URL with selection query params (?size=X&inseam=Y).
 * Strips any existing size/inseam params before applying the new ones.
 * Null or empty values are omitted from the resulting URL.
 */
export function buildUrlWithSelection(
  baseUrl: string,
  params: Partial<ProductSelectionParams>,
): string {
  const url = new URL(baseUrl, window.location.origin)

  url.searchParams.delete('size')
  url.searchParams.delete('inseam')

  if (params.size) {
    url.searchParams.set('size', params.size)
  }

  if (params.inseam) {
    url.searchParams.set('inseam', params.inseam)
  }

  return url.toString()
}
